import { Stack, usePathname } from "expo-router";
import { PageLayout } from "app/features/navigation/templates/PageLayout";

export default function AssessmentsLayout() {
  const pathname = usePathname();

  return (
    <PageLayout
      className="p-dashboard"
      currentPath={pathname}
      screenName="Assessments"
    >
      <Stack
        screenOptions={{
          headerShown: false,
          contentStyle: { backgroundColor: "white" },
        }}
      />
    </PageLayout>
  );
}
